<template>
  <div>
    This displays the previously captured photo (back to step 3 if needing additional
    photos (front/back/selfie))

    <router-link to="VerifyCompleted">Next</router-link>
  </div>
</template>

<script>
export default {};
</script> 

<style lang="sass" scoped></style>